<template>
  <b-form-input
    :id="id"
    v-bind="$attrs"
    ref="vtInput"
    :placeholder="placeholder"
    :class="[{ 'selected-value': highlightWhenSelectedValue && value }, classes]"
    :name="name"
    :disabled="disabled"
    :type="type"
    :number="number"
    :value="value"
    :formatter="formatter"
    :qa-value="value"
    :data-vv-name="name"
    :step="step"
    :plaintext="plainText"
    :min="min"
    :max="max"
    :size="size"
    :autocomplete="autoComplete"
    @keyup.enter="handleEnter()"
    @change.native="$emit('change', $event)"
    @focus.native="$emit('focus')"
    @input="$emit('input', $event)"
    @blur="$emit('blur', $event)"
  />
</template>

<script>
import { uniqueId } from 'lodash'

export default {
    name: 'VtInput',
    props: {
        id: String,
        disabled: { type: Boolean, default: false },
        type: { type: String, default: 'text' },
        value: {
            validator: (prop) => { return typeof prop === 'string' || typeof prop === 'number' || prop === null }
        },
        formatter: Function,
        plainText: { type: Boolean, default: false },
        min: { type: Number, default: 1 },
        max: { type: Number },
        step: { type: Number, default: 1 },
        size: String,
        classes: String,
        placeholder: String,
        name: { type: String, default: () => uniqueId('input') },
        highlightWhenSelectedValue: { type: Boolean, default: false },
        autocomplete: { type: Boolean, default: true },
        autofocus: { type: Boolean, default: false }
    },
    computed: {
        autoComplete() {
            return !this.autocomplete
                ? 'new-password'
                : ''
        },
        number() {
            return this.type === 'number'
        }
    },
    watch: {
        autofocus() {
            if (this.autofocus) {
                this.focus()
            }
        }
    },
    methods: {
        handleEnter() {
            if (this.value?.length > 0) {
                this.$emit('enter')
            }
        },
        focus() {
            this.$nextTick(() => this.$refs.vtInput.focus())
        }
    }
}

</script>

<style scoped lang="scss">

.vt-input {
  opacity: .5;
  border-color: vt-color(grey);
  color: vt-color(grey);

  &:focus {
    opacity: 1;
    border-color: vt-color(primary);
    box-shadow: none;
  }

  &:disabled {
    background-color: rgba(196, 196, 196, 0.3);
  }

  &.form-control-plaintext {
    color: vt-color('dark-text');
    border: none;

    &:disabled {
      color: vt-color('dark-text');
      background-color: transparent;
      opacity: 1;
    }
  }
}

</style>
